import React, { useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { ColorPopoverPicker } from '../../components/ColorPopoverPicker'
import { useMainContext } from '../../../context'
import { handlePostRequest, handleGetRequest } from '../../services'
import LoadingContext from '../../../_metronic/layout/core/Loading'
import toastr from '../../../toaster'

type Props = {
  className: string
}
const EditStatisticPage: React.FC<Props> = () => {
  const { setLoading } = useContext(LoadingContext)
  const [iFrameBackgroundColour, setIFrameBackgroundColour] = useState('#e9ecf3')
  const [graphBackgroundColor, setGraphBackgroundColor] = useState('#21285c')
  const [graphTitleFontColour, setGraphTitleFontColour] = useState('#999999')
  const [totalNumbersFontColour, setTotalNumbersFontColour] = useState('#FFFFFF')
  const [usersChartMarker, setUsersChartMarker] = useState('#FFFFFF')
  const [fundsChartMarker, setFundsChartMarker] = useState('#27b7eb')
  const [logoColor, setLogoColor] = useState('#21285c')
  const [historySectionVisibility, setHistorySectionVisibility] = useState<boolean>(true)
  const [buttonsSectionVisibility, setButtonsSectionVisibility] = useState<boolean>(true)
  const [logoVisibility, setLogoVisibility] = useState<boolean>(true)
  const [organisation_id, setOrganisation_id] = useState<string | null>(null)
  const context = useMainContext()
  const intl = useIntl()

  useEffect(() => {
    // get organisation_id from context or local storage
    const storedOrganisationId = localStorage.getItem('organisation_id')
    if (context && context.organisationId) {
      setOrganisation_id(context.organisationId)
      localStorage.setItem('organisation_id', context.organisationId)
    } else if (storedOrganisationId) {
      setOrganisation_id(storedOrganisationId)
    } else {
      console.log('org id not found')
    }
  }, [context])

  useEffect(() => {
    if (organisation_id) {
      // get theme settings from backend
      const getThemeSettings = async () => {
        try {
          const response = await handleGetRequest(`/organisation/theme/${organisation_id}`)(
            setLoading
          )
          if (response.data) {
            const themeSettings = response.data
            setIFrameBackgroundColour(themeSettings.iFrameBackgroundColour)
            setGraphBackgroundColor(themeSettings.graphBackgroundColor)
            setGraphTitleFontColour(themeSettings.graphTitleFontColour)
            setTotalNumbersFontColour(themeSettings.totalNumbersFontColour)
            setUsersChartMarker(themeSettings.usersChartMarker)
            setFundsChartMarker(themeSettings.fundsChartMarker)
            setHistorySectionVisibility(themeSettings.historySectionVisibility)
            setButtonsSectionVisibility(themeSettings.buttonsSectionVisibility)
            setLogoVisibility(themeSettings.logoVisibility)
            setLogoColor(themeSettings.logoColor)
          } else {
            resetToDefault()
          }
        } catch (error) {
          resetToDefault()
        }
      }
      getThemeSettings()
    }
  }, [organisation_id])

  const iframeCode = `<iframe src="https://vis.stotte.no/${organisation_id}?graphBackgroundColor=${encodeURIComponent(graphBackgroundColor)}&iFrameBackgroundColor=${encodeURIComponent(iFrameBackgroundColour)}&graphTitleFontColour=${encodeURIComponent(graphTitleFontColour)}&totalNumbersFontColour=${encodeURIComponent(totalNumbersFontColour)}&usersChartMarker=${encodeURIComponent(usersChartMarker)}&fundsChartMarker=${encodeURIComponent(fundsChartMarker)}&historySectionVisibility=${historySectionVisibility}&buttonsSectionVisibility=${buttonsSectionVisibility}&logoVisibility=${logoVisibility}&logoColor=${logoColor}" width="60%" height="100%" title="Støtte statistic frame" />`

  const themeSettings = {
    organisation_id,
    graphBackgroundColor,
    iFrameBackgroundColour,
    graphTitleFontColour,
    totalNumbersFontColour,
    usersChartMarker,
    fundsChartMarker,
    historySectionVisibility,
    buttonsSectionVisibility,
    logoVisibility,
    logoColor,
  }
  const submitForam = async (themeSettings: any) => {
    try {
      const respone = await handlePostRequest(`/organisation/theme/${organisation_id}`, {
        themeSettings,
      })(setLoading)
      if (respone) {
        setLoading(false)
        toastr.success('Theme saved successfully!')
      }
    } catch (error) {
      console.error('ERROR:', error)
    }
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(iframeCode).then(() => {
      alert('Kode kopiert til utklippstavlen!')
    })
  }
  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLogoColor(event.target.value === 'blue' ? '#21285c' : '#FFFFFF')
  }

  const resetToDefault = () => {
    setIFrameBackgroundColour('#e9ecf3')
    setGraphBackgroundColor('#21285c')
    setTotalNumbersFontColour('#FFFFFF')
    setGraphTitleFontColour('#999999')
    setUsersChartMarker('#FFFFFF')
    setFundsChartMarker('#27b7eb')
    setHistorySectionVisibility(true)
    setButtonsSectionVisibility(true)
    setLogoVisibility(true)
    setLogoColor('#21285c')
  }
  const urlEncode = (val: string) => {
    return encodeURIComponent(val)
  }

  return (
    <>
      <div className={`card `}>
        <div>
          <div className='card-body h-auto'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap m-5'>
                  <div className='d-flex flex-row w-100' style={{ height: '100vh' }}>
                    <div
                      className='fs-2 fw-bolder me-1'
                      style={{ color: 'black', flex: '0 0 60%' }}
                    >
                      <iframe
                        src={`https://vis.stotte.no/${organisation_id}?graphBackgroundColor=${urlEncode(graphBackgroundColor)}&iFrameBackgroundColor=${urlEncode(iFrameBackgroundColour)}&graphTitleFontColour=${urlEncode(graphTitleFontColour)}&totalNumbersFontColour=${urlEncode(totalNumbersFontColour)}&usersChartMarker=${urlEncode(usersChartMarker)}&fundsChartMarker=${urlEncode(fundsChartMarker)}&historySectionVisibility=${historySectionVisibility}&buttonsSectionVisibility=${buttonsSectionVisibility}&logoVisibility=${logoVisibility}&logoColor=${urlEncode(logoColor)}`}
                        width='60%'
                        height='100%'
                        title='Støtte statistic frame'
                      />
                    </div>
                    <div
                      className='fs-2 fw-bolder me-1'
                      style={{ color: 'black', flex: '0 0 40%' }}
                    >
                      <div>
                        <div className='fb-control-group d-flex flex-wrap'>
                          <div className='primary-fb-colour p-4' style={{ flex: '0 0 40%' }}>
                            {intl.formatMessage({ id: 'iframe.background.color' })}

                            <ColorPopoverPicker
                              color={iFrameBackgroundColour}
                              onChange={setIFrameBackgroundColour}
                              text={false}
                            />
                          </div>
                          <div className='primary-fb-colour p-4' style={{ flex: '0 0 40%' }}>
                            {intl.formatMessage({ id: 'graph.background.color' })}
                            <ColorPopoverPicker
                              color={graphBackgroundColor}
                              onChange={setGraphBackgroundColor}
                              text={false}
                            />
                          </div>
                          <div className='primary-fb-colour p-4' style={{ flex: '0 0 40%' }}>
                            {intl.formatMessage({ id: 'graph.title.font' })}
                            <ColorPopoverPicker
                              color={graphTitleFontColour}
                              onChange={setGraphTitleFontColour}
                              text={false}
                            />
                          </div>
                          <div className='primary-fb-colour p-4' style={{ flex: '0 0 40%' }}>
                            {intl.formatMessage({ id: 'total.number.font.color' })}
                            <ColorPopoverPicker
                              color={totalNumbersFontColour}
                              onChange={setTotalNumbersFontColour}
                              text={false}
                            />
                          </div>
                          <div className='primary-fb-colour p-4' style={{ flex: '0 0 40%' }}>
                            {intl.formatMessage({ id: 'funds.chart.marker' })}
                            <ColorPopoverPicker
                              color={fundsChartMarker}
                              onChange={setFundsChartMarker}
                              text={false}
                            />
                          </div>
                          <div className='primary-fb-colour p-4' style={{ flex: '0 0 40%' }}>
                            {intl.formatMessage({ id: 'users.chart.marker' })}
                            <ColorPopoverPicker
                              color={usersChartMarker}
                              onChange={setUsersChartMarker}
                              text={false}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: '10px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                          borderRadius: '5px',
                          padding: '15px',
                          width: '70%',
                        }}
                      >
                        <label>
                          <input
                            name='historySectionVisibility'
                            type='checkbox'
                            style={{ marginRight: '15px', width: '20px', height: '20px' }}
                            checked={historySectionVisibility}
                            onChange={(e) => setHistorySectionVisibility(e.target.checked)}
                          />
                          {intl.formatMessage({ id: 'history.section.visibility' })}
                        </label>
                      </div>
                      <div
                        style={{
                          marginTop: '10px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                          borderRadius: '5px',
                          padding: '15px',
                          width: '70%',
                        }}
                      >
                        <label>
                          <input
                            name='visibilityOfButtons'
                            type='checkbox'
                            style={{ marginRight: '15px', width: '20px', height: '20px' }}
                            checked={buttonsSectionVisibility}
                            onChange={(e) => setButtonsSectionVisibility(e.target.checked)}
                          />
                          {intl.formatMessage({ id: 'button.section.visibility' })}
                        </label>
                      </div>
                      <div
                        style={{
                          marginTop: '10px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                          borderRadius: '5px',
                          padding: '15px',
                          width: '70%',
                          marginBottom: '15px',
                        }}
                      >
                        <label>
                          <input
                            name='visibilityOfLogo'
                            type='checkbox'
                            style={{ marginRight: '15px', width: '20px', height: '20px' }}
                            checked={logoVisibility}
                            onChange={(e) => setLogoVisibility(e.target.checked)}
                          />
                          {intl.formatMessage({ id: 'logo.visibility' })}
                        </label>
                        <div
                          style={{ marginTop: '10px', display: logoVisibility ? 'flex' : 'none' }}
                        >
                          <input
                            type='radio'
                            id='blue'
                            name='pickColor'
                            value='blue'
                            checked={logoColor === '#21285c'}
                            style={{ marginRight: '5px', width: '20px', height: '20px' }}
                            onChange={handleColorChange}
                          />
                          <label htmlFor='blue' style={{ marginRight: '15px' }}>
                            {intl.formatMessage({ id: 'blue' })}
                          </label>
                          <input
                            type='radio'
                            id='white'
                            name='pickColor'
                            value='white'
                            checked={logoColor === '#FFFFFF'}
                            style={{ marginRight: '5px', width: '20px', height: '20px' }}
                            onChange={handleColorChange}
                          />
                          <label htmlFor='white'>{intl.formatMessage({ id: 'white' })}</label>{' '}
                          <br />
                        </div>
                      </div>

                      <div>
                        <button
                          className='btn btn-primary mb-5'
                          onClick={() => {
                            resetToDefault()
                          }}
                        >
                          {intl.formatMessage({ id: 'reset.to.default.setting' })}
                        </button>
                      </div>
                      <div>
                        <button
                          className='btn btn-success'
                          onClick={() => {
                            submitForam(themeSettings)
                          }}
                        >
                          {intl.formatMessage({ id: 'save.theme' })}
                        </button>
                      </div>
                      <div>
                        <div style={{ marginTop: '30px', maxWidth: '450px' }}>
                          <h3>{intl.formatMessage({ id: 'iframe.code' })}</h3>
                          <pre style={{ padding: '5px' }}>
                            <code style={{ padding: '8px' }}>{iframeCode}</code>
                          </pre>
                          <button onClick={copyToClipboard} className='btn btn-secondary'>
                            {intl.formatMessage({ id: 'copy.code' })}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='mt-5'>
                    <div className='card campaign-info mb-3'>
                      <div className='text-section'>
                        <div className='card-header border-0 pt-5'>
                          <h3
                            className='card-title align-items-start flex-column'
                            style={{ maxWidth: '70%' }}
                          >
                            <span className='card-label fw-bold fs-3 mb-1'>
                              Bruksanvisning for inntektsgrafen i Støtte
                            </span>
                          </h3>
                        </div>
                        <div className='card-body py-3'>
                          <p>
                            Denne grafen gir klubber en oversikt over inntektene fra uke til uke.
                            Klubben kan enkelt tilpasse grafens utseende for å matche sine egne
                            klubbfarger og visuelle profil. Følg disse stegene for å sette opp og
                            bruke grafen på deres nettside:
                          </p>
                          <ul>
                            <li>
                              <b>Forstå grafen</b>
                              <ul>
                                <li>
                                  Grafen viser klubbens inntekter over en periode på seks måneder.
                                </li>
                                <li>
                                  Den blå linjen representerer inntekter mens den hvite linjen viser
                                  antall brukere som bidrar.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <b>Tilpass utseendet</b>
                              <ul>
                                <li>
                                  På høyre side av skjermen finner du ulike alternativer for å
                                  tilpasse grafen:
                                </li>
                                <li>Endre bakgrunnsfarge på grafen og rammen.</li>
                                <li>Justere farger på titteltekst og tall.</li>
                                <li>Tilpasse fargene på inntekts- og brukermarkører.</li>
                                <li>Velge mellom en blå eller hvit logo.</li>
                              </ul>
                            </li>
                            <li>
                              <b>Skru av og på seksjoner</b>
                              <ul>
                                <li>
                                  Du kan velge å vise eller skjule historikkseksjonen og
                                  knappeseksjonen for en mer tilpasset visning.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <b>Lagre og kopier koden</b>
                              <ul>
                                <li>
                                  Når du er fornøyd med innstillingene, trykker du på “Lagre tema”.
                                </li>
                                <li>Deretter kopierer du koden nederst på skjermen.</li>
                                <li>
                                  Lim denne koden inn på klubbens hjemmeside for å vise grafen der.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <b>Hvorfor bruke grafen?</b>
                              <ul>
                                <li>
                                  Med denne løsningen kan klubben enkelt følge med på inntekter over
                                  tid.
                                </li>
                                <li>
                                  Grafen kan integreres på klubbens nettside, slik at medlemmer og
                                  støttespillere ser hvordan de bidrar.
                                </li>
                                <li>
                                  På samme måte som andre aktører har sine grafer for inntekter, gir
                                  denne grafen en visuell og transparent måte å vise midler inn til
                                  klubben fra Støtte.
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div> </div>
    </>
  )
}

export default EditStatisticPage
